export default __webpack_public_path__ + "static/media/nonagonDevice.d841c48b.svg";